function tooltips () {
    const tooltipTrigger = document.querySelectorAll('.tooltip-trigger');

    if(tooltipTrigger.length > 0) {
        if(window.innerWidth >= 1241) {
            tooltipTrigger.forEach(el=> {
                el.addEventListener('mouseenter', function() {
                    const parent = this.closest('.tooltip-parent');
                    const tooltip = parent.querySelector('.tooltip');
    
                    tooltip.classList.add('show');
                });
    
                el.addEventListener('mouseleave', function() {
                    const parent = this.closest('.tooltip-parent');
                    const tooltip = parent.querySelector('.tooltip');
    
                    tooltip.classList.remove('show');
                });
            });
        }

        if(window.innerWidth <= 1240) {
            const tooltipsContainer = document.querySelectorAll('.tooltip-parent');
            let currentTooltip = null;
            let currentParent = null;

            tooltipTrigger.forEach(el => {
                el.addEventListener('click', function () {
                    tooltipTrigger.forEach (el=> el.classList.remove('active'));
                    this.classList.add('active');

                    const parent = this.closest('.tooltip-parent');
                    const tooltip = parent ? parent.querySelector('.tooltip') : null;

                    // Если тултип не найден, выходим
                    if (!tooltip) return;

                    // Если уже есть открытый тултип, возвращаем его на место
                    if (currentTooltip && currentTooltip !== tooltip) {
                        if (currentParent) {
                            currentParent.appendChild(currentTooltip); // Возвращаем предыдущий тултип
                            currentTooltip.classList.remove('show');
                            currentParent.classList.remove('tooltip-moved');
                        }
                    }

                    // Переносим новый тултип в body
                    document.body.appendChild(tooltip);
                    setTimeout(()=>{tooltip.classList.add('show'), 100});

                    parent.classList.add('tooltip-moved');

                    // Обновляем переменные с текущим тултипом и родителем
                    currentTooltip = tooltip;
                    currentParent = parent;

                    // Обрабатываем скрытие других тултипов
                    tooltipsContainer.forEach(el => {
                        if (el !== parent && el.classList.contains('tooltip-moved')) {
                            const otherTooltip = el.querySelector('.tooltip');
                            if (otherTooltip) {
                                el.appendChild(otherTooltip); // Возвращаем предыдущий тултип в его родительский элемент
                                otherTooltip.classList.remove('show');
                                el.classList.remove('tooltip-moved');
                            }
                        }
                    });
                });
            });

            // Обработчик клика по кнопке закрытия тултипа
            const tooltipClose = document.querySelectorAll('.tooltip-close');

            tooltipClose.forEach(el=> {
                el.addEventListener('click', function () {
                    tooltipTrigger.forEach (el=> el.classList.remove('active'));
                    
                    if (currentTooltip) {
                        currentTooltip.classList.remove('show');

                        if (currentParent) {
                            currentParent.appendChild(currentTooltip); // Возвращаем тултип на место
                            currentParent.classList.remove('tooltip-moved');
                        }
    
                        // Очищаем переменные
                        currentTooltip = null;
                        currentParent = null;
                    }
                });
            });
        }
    }
}

export default tooltips;